import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteAvsKvpsSchema = z.object({
  id: z.number(),
});

export const getAvsKvpsRequestSchema = z.object({
  sort: zodSortField(["label"]),
});

export const addAvsKvpsSchema = z.object({
  label: z
    .string()
    .min(1, "Le Libellé est requis")
    .max(200, "Maximum de caractères atteint"),
  kvps: z
    .string()
    .regex(/^([A-Z]{3})(\d{5}|995)([A,C,N,S,V])$/, "Le kvps est incohérent"),
});

export const editAvsKvpsSchema = z.object({
  id: z.number().optional(),
  label: z
    .string()
    .min(1, "Le Libellé est requis")
    .max(200, "Maximum de caractères atteint"),
  kvps: z
    .string()
    .regex(/^([A-Z]{3})(\d{5}|995)([A,C,N,S,V])$/, "Le kvps est incohérent"),
  isActive: z.boolean().default(true),
});
